export { default } from "./represents";

export type { Represents } from "./represents.types";
